import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';

interface SessionNodeData {
  label: string;
  phase: string;
  agentCount: number;
  artifactCount: number;
  status: 'active' | 'completed' | 'error';
  thumbnail?: string;
}

const SessionNode: React.FC<NodeProps<SessionNodeData>> = ({ data, isConnectable }) => {
  const getStatusColor = () => {
    switch (data.status) {
      case 'active': return 'bg-green-500';
      case 'completed': return 'bg-blue-500';
      case 'error': return 'bg-red-500';
      default: return 'bg-gray-500';
    }
  };

  return (
    <div className="session-node bg-white rounded-lg shadow-lg border border-gray-200 p-3 min-w-[200px]">
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        className="w-3 h-3"
      />
      
      <div className="flex items-start">
        {data.thumbnail && (
          <div className="mr-3 flex-shrink-0">
            <img src={data.thumbnail} alt="" className="w-10 h-10 rounded object-cover" />
          </div>
        )}
        
        <div className="flex-grow">
          <div className="flex items-center justify-between mb-1">
            <h3 className="font-medium text-gray-900 truncate">{data.label}</h3>
            <span className={`inline-block w-3 h-3 rounded-full ${getStatusColor()}`}></span>
          </div>
          
          <div className="text-xs text-gray-500 mb-2">
            Phase: {data.phase}
          </div>
          
          <div className="flex text-xs text-gray-600 space-x-3">
            <span>{data.agentCount} agents</span>
            <span>{data.artifactCount} artifacts</span>
          </div>
        </div>
      </div>
      
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
        className="w-3 h-3"
      />
    </div>
  );
};

export default memo(SessionNode);
